import { useFormContext } from '@dagens/frontend-forms';
import { useTranslation } from '@dagens/frontend-i18n';
import { ActionButton } from '../../../../components/action-button';
import { type ReqType } from '../../../../utils/REQ';
import { SelfDeliveryFeeFormValues } from './form';

type Props = {
  saveReq: ReqType;
  onSubmit: (data: SelfDeliveryFeeFormValues) => void;
};

export const SelfDeliveryFeeFormSubmitButton = ({
  saveReq,
  onSubmit
}: Props) => {
  const { t } = useTranslation();
  const { handleSubmit } = useFormContext<SelfDeliveryFeeFormValues>();
  return (
    <ActionButton.Save
      onClick={handleSubmit(onSubmit)}
      redirectTo={-1}
      saveReq={saveReq}
    >
      {t('producer:SelfDeliveryFeeSave')}
    </ActionButton.Save>
  );
};
